import React, { useEffect, useState, useRef } from "react";
import WidgetHeader from "../../../../components/Widget/Header";
import { FormattedDate, FormattedTime } from 'react-intl'
import useCurrentUser from 'hooks/useCurrentUser'
import { useHistory } from 'react-router-dom'

const MyActionTaskWidget = ({ widget }) => {
  const mounted = useRef(false);
  const history = useHistory()

  const { features = [], roles = [] } = useCurrentUser()
  const [tasks, setTasks] = useState([]);
  const [title, setTitle] = useState("");

  useEffect(() => {
    mounted.current = true;
    const url = roles.includes('coordinator') ?
      "coordinatordashboard/My_Action_Tasks" :
      "supplierdashboard/Action_Tasks"
      
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (mounted.current) {
          setTasks(data.data.tasks);
        }
      });

    setTitle(widget.widgetId.replace(/_/g, " "));

    return () => {
      mounted.current = false;
    };
  }, [roles]);

  const getDeadline = (task) => {
    const value = new Date(task["deadline"] * 1000)
    return <div>
      <span className="mr-1">
        <FormattedDate value={value} />
      </span>
      <span>
        <FormattedTime value={value} />
      </span>
    </div>
  };

  const getDeadlineStatus = (task) => {
    if (parseInt(task["deadline"]) - Date.now()/1000 > 86400) {
      return (
        <i
          className="block rounded-full w-2 h-2 bg-green-500"
          title="Deadline is not within the next 24 hours"
        ></i>
      );
    } else if (parseInt(task["deadline"]) - Date.now()/1000 > 0) {
      return (
        <i
          className="block rounded-full w-2 h-2 bg-yellow-500"
          title="Close to deadline!"
        ></i>
      );
    } else {
      return (
        <i
          className="block rounded-full w-2 h-2 bg-red-600"
          title="Deadline passed"
        ></i>
      );
    }
  };

  const getStatusChangedAt = (task) => {
    const value = new Date(task["status_changed_at"] * 1000)
    return <div>
      <span className="mr-1">
        <FormattedDate value={value} />
      </span>
      <span>
        <FormattedTime value={value} />
      </span>
    </div>
  };

  const taskTitle = (task) => {
    return `${task["title"]} ${
      task["endCustomer"] != "" ? `(${task["endCustomer"]})` : ""
    }`;
  };

  const onNavigateToTask = (uid) => {
    history.push(`/task/${uid}`)
  };

  const removeOrder = (uid) => {
    const data = new URLSearchParams();
    data.append('table', 'ordertask');
    data.append('field', 'removeFromActionList');
    data.append('rowid', uid);
    data.append('val', 1);

    fetch('/update/field', {
      method: 'POST',
      body: data
    }).then(() => {
      setTasks(tasks.filter((task) => task["uid"] !== uid));
    });
  }

  const getTask = (task) => {
    return <div key={task.uid} className="hover:bg-gray-200 flex border-b">
      <div className="shrink-0 pl-4 pr-2 py-2 w-20">{task["shortname"]}</div>

      <div
        className="flex-grow px-2 py-2 cursor-pointer hover:text-primary truncate"
        onClick={() => onNavigateToTask(task.uid, task.orderid)}
      >
        <div className="truncate" title={taskTitle(task)}>
          {taskTitle(task)}
        </div>
        <div
          className="text-xs text-gray-500 truncate"
          title={task['status']}
        >
          {task["status"]}
        </div>
      </div>

      <div className="shrink-0 pr-4 pl-2 py-2 flex justify-between items-center space-x-4">
        <div>
          <div className="flex w-full">
            <span className="text-xs my-auto mr-2">
              {getDeadlineStatus(task)}
            </span>
            {getDeadline(task)}
          </div>
          <div
            className="text-xs text-gray-500 flex"
            title={`Last status change was at ${getStatusChangedAt(
              task
            )}`}
          >
            <i
              title=""
              className="mr-1 fal fa-history text-xs text-gray-400"
            ></i>
            {getStatusChangedAt(task)}
          </div>
        </div>
        <i
          title="Remove from My Action Tasks"
          className="text-gray-400 hover:text-primary fa fa-times cursor-pointer"
          onClick={() => removeOrder(task["uid"])}
        ></i>
      </div>
    </div> 
  }

  const widget_id = `ID_${widget.widgetId}`;
  return (
    <div
      className="bg-white border shadow rounded border-gray-400"
      id={widget_id}
    >
      <WidgetHeader widget={widget} widgetTitle={title} />

      <div className="w-full text-xs">
        {tasks.filter(t => t.automated == '0').map((task) => {
          return getTask(task);
        })}

        {tasks.filter(t => t.automated == '1').length > 0 && <div className="bg-gray-100 flex border-b px-4 py-2 font-medium">
          Automated Orders{" "}
          <i className="fa fa-arrow-down text-gray-500 ml-2"></i>
        </div>}

        {tasks.filter(t => t.automated == '1').map((task) => {
          return getTask(task);
        })}

      </div>
    </div>
  );
};

export default MyActionTaskWidget;
